import {Component, Input, OnInit} from '@angular/core';
import {DiaModel, SemanaModel} from '../models/semana.model';
import {SemanaServices} from '../services/semana.services';
import {ConfigServices} from '../../CoreModule/services/config.services';

import {TiendaServices} from '../../CoreModule/services/tienda.services';
import * as moment from 'moment';
import * as lodash from 'lodash';

import {TiendaEntity} from '../../CoreModule/entities/tienda.entity';
import {OPCCAT, OPCLOC, OPCNEG, PERMISOS} from '../../variables';
import {NgxSpinnerService} from 'ngx-spinner';
import {forkJoin, Observable} from 'rxjs';
import {Router} from '@angular/router';
import {OnPermisos} from '../../CoreModule/interfaces/security.interface';
import {getLoginUser, UsuarioServices} from '../../CoreModule/services/usuario.services';
import {SocketServices} from '../../CoreModule/services/socket.services';

@Component({
  selector: 'semana',
  templateUrl: '../templates/semanas/semana.template.html',
  styleUrls: []
})
export class SemanaComponent {
  @Input()
  semana: SemanaModel;

  @Input()
  mostrarVentas: boolean = false;

  @Input()
  mostrarEdicion: boolean = false;

  @Input()
  mostrarPesos: boolean = false;

  dias: any[] = [];

  enablePesos: boolean = false;
  enableEdicion: boolean = false;

  constructor() {
    for (let i = 0; i < 24; i++) {
      this.dias.push(`${i}:00`);
      this.dias.push(`${i}:30`);
    }
  }

  cambiarPorcDia(indSem: any, $cantidad) {

    let diaSelect = this.semana.mPorcentaje.dias[indSem];

    let cantAnt = diaSelect.porcentaje;
    let diff = cantAnt - +$cantidad;
    diaSelect.porcentaje = +$cantidad;
    let dias0 = this.semana.mPorcentaje.dias.filter(d => {
      if (d != diaSelect)
        if (d.porcentaje == 0)
          return d;
    }).length;

    let step = diff / (6 - dias0);

    this.semana.mPorcentaje.dias.map(d => {
      if (d != diaSelect && d.porcentaje > 0)
        d.porcentaje += step;
    });


  }

  cambiarPorcHora(dia: DiaModel, indHora: any, $cantidad) {
    let horaSelect = dia.horas[indHora];
    let cantAnt: number = horaSelect.porcentaje;
    let diff = cantAnt - +$cantidad;

    horaSelect.porcentaje = +$cantidad;
    let horas = dia.horas.filter(h => {
      if (h != horaSelect)
        if (h.porcentaje > 0)
          return h;
    });


    let step = diff / horas.length;


    horas.map(h => {
      h.porcentaje += step;
    });

    let tot = 0;
    dia.horas.map(h => {
      tot += h.porcentaje;
    });


  }

  cambiarEdicion($event) {


    if ($event) {
      this.semana.acciones = 2;
      this.enableEdicion = true;
      this.enablePesos = false;
    } else {
      this.semana.acciones = 0;
      this.enableEdicion = false;
      this.enablePesos = false;
    }

  }

  cambiarPesos($event) {
    if ($event) {
      this.semana.acciones = 1;
      this.enableEdicion = false;
      this.enablePesos = true;
    } else {
      this.semana.acciones = 0;
      this.enableEdicion = false;
      this.enablePesos = false;
    }
  }
}

@Component({
  selector: 'dia',
  templateUrl: '../templates/semanas/dia.template.html',
  styleUrls: []
})
export class DiaComponent {
  @Input()
  dia: DiaModel;
}

@Component({
  selector: 'hora',
  templateUrl: '../templates/semanas/hora.template.html',
  styleUrls: []
})
export class HoraComponent {

}

@Component({
  selector: 'asig-sem',
  templateUrl: '../templates/semanas/asignacion.semana.template.html',
  styleUrls: []
})
export class AsignacionSemanaComponent implements OnInit {

  semanaModelo: SemanaModel;


  tiendaSelect: any = null;
  semSelect: any = null;
  semProgSelect: any = null;

  opcTiendas: any[] = [];

  configTiendas: any = {'placeholder': 'Seleccione una tienda', 'sourceField': ['payload', 'label']};
  configSemanas: any = {'placeholder': 'Seleccione una semana modelo', 'sourceField': ['payload', 'label']};
  opcSemanas: any[] = [];

  configProg: any = {'placeholder': 'Seleccione la semana a programar', 'sourceField': ['payload', 'label']};
  opcProg: any[] = [];


  opcNegocio: string[] = OPCNEG;
  opcLocacion: string[] = OPCLOC;
  opcCategoria: string[] = OPCCAT;

  filtroAsign: number = 1;

  filtroLoc: string = '';
  filtroCat: string = '';
  filtroNeg: string = '';

  todasTiendas: TiendaEntity[] = [];
  tiendasFilt: TiendaEntity[] = [];

  tiendasQuitar: any[] = [];


  constructor(private ss: SemanaServices, private cs: ConfigServices, private ts: TiendaServices, private spinner: NgxSpinnerService) {
    // this.semanaModelo = sem;
    // this.semanaProyectada = lodash.cloneDeep(sem);

    // this.semanaProyectada.ventasSem = this.presupuesto;
    //
    // this.semanaProyectada.recalcular();


////////////////////////////////////////////////////////////////////////////
    this.ts.getAllTiendas().subscribe(d => {

      this.todasTiendas = d.data.tiendas.filter(t => {
        return (t.activo == 1);
      });

      this.todasTiendas.sort((a: any, b: any) => {
        if (a.nombre > b.nombre)
          return 1;
        else
          return -1;
      });

      this.tiendasFilt = this.todasTiendas;

      for (let t of d.data.tiendas) {

        if (t.activo == 1) {
          this.opcTiendas.push({
            id: t.idDB,
            payload: {label: t.nombre}
          });
        }
      }
    });

    this.cs.getAnos().subscribe(d => {


      // this.opcSemanas.push({
      //   id: 0,
      //   payload: {label: 'Semana del año anterior'}
      // });

      for (let a of d.data.anos) {

        for (let i = 0; i < 53; i++) {

          let semIter = moment(a.primerDia).add(i, 'w').format('YYYY-MM-DD');
          this.opcSemanas.push({
            id: `S${i + 1} - ${a.ano}`,
            payload: {label: `S${i + 1} ${semIter}`},
            ano: a.ano,
            semana: i
          });
        }

      }


    });

    let ano = moment().year();
    let day = moment().date();
    let month = moment().month();

    if (day > 25 && month == 11)
      ano++;

    // // quitar, solo se dejo para hacer prueba de los indicadores
    // let ano = 2019;

    this.cs.getAno(ano).subscribe(d => {

      let primerDia = moment(d.data.ano.primerDia);
      for (let i = 0; i < 53; i++) {

        let semIter = moment(primerDia).add(i, 'w');

        this.opcProg.push({
          id: `S${i + 1} - ${primerDia.year()}`,
          payload: {label: `S${i + 1} ${semIter.format('YYYY-MM-DD')}`},
          ano: d.data.ano.ano,
          semana: i,
          fecha: semIter.format('YYYY-MM-DD')
        });
      }


    });

    this.cs.getAno(ano-1).subscribe(d => {

      let primerDia = moment(d.data.ano.primerDia);
      for (let i = 0; i < 53; i++) {

        let semIter = moment(primerDia).add(i, 'w');

        this.opcProg.push({
          id: `S${i + 1} - ${primerDia.year()}`,
          payload: {label: `S${i + 1} ${semIter.format('YYYY-MM-DD')}`},
          ano: d.data.ano.ano,
          semana: i,
          fecha: semIter.format('YYYY-MM-DD')
        });
      }


    });


  }

  selectTienda(tienda: any) {

    this.tiendaSelect = tienda;
  }

  changeTienda(tienda: any) {

  }

  selectSemana(semana: any) {

    this.semSelect = semana;
  }

  changeSemana(semana: any) {

  }

  selectProg(prog: any) {
    console.log(prog);
    this.semProgSelect = prog;
  }

  changeProg(prog: any) {
    console.log(prog);
  }

  obtenerSemanaModelo() {

    this.spinner.show();
    this.tiendasFilt = lodash.clone(this.todasTiendas);

    this.tiendasFilt.sort((a: any, b: any) => {
      if (a.nombre > b.nombre)
        return 1;
      else
        return -1;
    });

    this.ss.devolverVentasTS(this.semSelect.ano, this.semSelect.semana, this.tiendaSelect.id).subscribe(d => {
      console.log(d);
      // console.log(this.semProgSelect.fecha);
      this.semanaModelo = this.ss.crearSemana(d.data.ventasTS, this.semProgSelect.fecha);
      this.spinner.hide();
    });
  }


  filtrarTiendas() {

    this.tiendasFilt = lodash.clone(this.todasTiendas);

    console.log(`${this.filtroLoc} ${this.filtroCat} ${this.filtroNeg}`);

    if (this.filtroNeg != '')
      this.tiendasFilt = this.tiendasFilt.filter(t => t.negocio == this.filtroNeg);

    if (this.filtroCat != '')
      this.tiendasFilt = this.tiendasFilt.filter(t => t.categoria == this.filtroCat);

    if (this.filtroLoc != '') {
      this.tiendasFilt = this.tiendasFilt.filter(t => t.locacion == this.filtroLoc);
    }

    this.tiendasFilt.sort((a: any, b: any) => {
      if (a.nombre > b.nombre)
        return 1;
      else
        return -1;
    });

  }


  quitarTienda() {
    console.log(this.tiendasQuitar);
    this.tiendasFilt = this.tiendasFilt.filter(t => {

      let found = this.tiendasQuitar.find(q => q == t.id);

      if (found)
        return false;
      else
        return true;
    });

    console.log(this.tiendasFilt);
    this.tiendasQuitar = [];
  }


  ngOnInit() {
    // this.semanaModelo = this.ss.devolverSemanaActual();

    // this.todasSem = this.ss.devolverTodasSemanas();


  }


  crearSemanas() {
    if (this.tiendasFilt.length == 0) {
      alert('No hay ninguna tienda seleccionada');
      return;
    }

    // se adiciona uno porque en los arrays se inicia con 0


    let fecha = `${this.semProgSelect.ano}-${this.semProgSelect.semana + 1}`;
    let tiendas: string[] = [];

    if (this.filtroAsign == 1) {
      tiendas.push(this.tiendaSelect.id);
    } else {
      for (let t of this.tiendasFilt) {
        tiendas.push(t.idDB);
      }
    }


    this.ss.guardarSemanas(this.semanaModelo, tiendas, fecha).subscribe(d => {
      // console.log(d.data.crearSemana);
      alert(d.data.crearSemana);
    });

  }

}

@Component({
  selector: 'presu-sem',
  templateUrl: '../templates/semanas/presupuesto.semana.template.html'
})
export class PresupuestoSemanaComponent implements OnInit {
  public datosCargados: any;
  public separador: string = '';
  public anoSelect: string = '';
  public semSelect: string = '';

  public tiendas: TiendaEntity[] = [];
  public semanas: SemanaModel[] = [];

  tASignadas = 0;
  tCargadas = 0;

  public obsSendLogPPTO: Observable<any>;
  logsProceso: any[] = [];
  cantSinActPpto = 0;
  cantActPpto = 0;
  logFinal = '';
  bloquearConsulta = false;
  filePpto: any;

  constructor(private ts: TiendaServices, private ss: SemanaServices, private spinner: NgxSpinnerService, private router: Router, private socs: SocketServices) {
    this.obsSendLogPPTO = this.socs.registrarEvento('logPpto');
  }

  ngOnInit() {
    this.ts.getAllTiendas().subscribe(d => {
      this.tiendas = d.data.tiendas;
    });

    this.obsSendLogPPTO.subscribe(d => {
      if (d.code != 0) {
        this.logsProceso.push(d);
        switch (d.code) {
          case -1:
            this.cantSinActPpto++;
            break;
          default:
            this.cantActPpto++;
            break;
        }
      } else {
        this.logFinal = d.msg;
        this.bloquearConsulta = false;
        this.spinner.hide();
      }
    });
  }

  devolverTipoLog(tipo: number) {

    switch (tipo) {
      case -1:
        return 'text-warning';
      case 1:
      case 2:
        return 'text-primary';

      case -2:
        return 'text-danger';
    }
  }

  async procesarPresupuestos(input: any) {
    let pptos: any[] = [];

    let reader = new FileReader();

    return new Promise<any>((resolve, reject) => {
      if (input.files.length > 0) {
        reader.readAsText(input.files[0]);

        reader.onload = (data) => {
          let csvData = reader.result;

          let filas = (csvData as string).split('\n');

          for (let i = 1; i < filas.length; i++) {
            let dt = filas[i].split(this.separador);

            pptos.push({
              tienda: dt[0],
              ppto: dt[1]
            });

          }

          resolve(pptos);
        };
      } else
        reject('Archivo en blanco');
    });


  }

  cargarArchivoPpto($event) {
    this.filePpto = $event.target;
  }

  async cargarPpto() {
    if (this.separador == '') {
      alert('Debe ingresar un separador');
      return;
    }
    let infoPpto = {};
    try {
      infoPpto = await this.procesarPresupuestos(this.filePpto);
    } catch (e) {
      alert('Error procesando el archivo de pptos, revise el formato del archivo asi como si es un ppto normal o por días');
      return;
    }

    if (confirm(`Desea cargar el ppto por semana para el periodo ${this.anoSelect}-${this.semSelect}`)) {
      this.logsProceso = [];
      this.bloquearConsulta = true;
      this.logFinal = "";
      this.spinner.show();

      this.socs.enviarEvento("subirPpto", {
        semActual:this.semSelect,
        anoAct: this.anoSelect,
        pptos: infoPpto
      })
    }
  }


  cargarDatos($event) {
    this.datosCargados = $event;
  }

  cargarSemanas(datos: any[]) {
    this.spinner.show();
    this.ss.devolverInfoSemana(`${this.anoSelect}-${this.semSelect}`).subscribe(d => {

      this.semanas = [];

      d.data.semanas.forEach(s => {

        let sem: SemanaModel = SemanaModel.CrearSemana(s);
        this.semanas.push(sem);
      });

      let semAsig = [];
      this.semanas.forEach(s => {
        let pre = datos.find(t => t.tienda == s.tienda);

        if (pre) {
          // console.log(`asignando precio ${pre.presupuesto}`);
          s.ventasSem = +pre.presupuesto;
          s.recalcularPrecio();
          // console.log(`precio es ${s.ventasSem}`);

          semAsig.push(s);
        }
      });

      // console.log(this.semanas);
      // console.log(`Tiendas asignadas ${semAsig.length}`);
      this.tASignadas = semAsig.length;
      // console.log(`Tiendas sin presupuesto ${this.semanas.length - semAsig.length}`);


      let obs = this.ss.actualizarPresupuestoSemana(semAsig);

      forkJoin(obs).subscribe(d => {
        this.spinner.hide();
        console.log(d);
        alert(`Tiendas asignadas ${this.tASignadas}, Tiendas sin presupuesto ${this.semanas.length - semAsig.length}`);
        // this.router.navigate(['/']);
      });

      // obs.forEach(o => {
      //   o.subscribe(d2 => {
      //     console.log(d2);
      //   });
      // });


    });
  }

  asignarPresupuestos() {

    if (this.datosCargados) {

      let files = this.datosCargados.srcElement.files;


      let datos: any[] = [];


      let input = this.datosCargados.target;
      let reader = new FileReader();

      if (input.files.length > 0) {
        let tiCarg = 0;
        reader.readAsText(input.files[0]);

        reader.onload = (data) => {
          let csvData = reader.result;

          let filas = (csvData as string).split('\n');


          for (let i = 1; i < filas.length; i++) {
            if (filas[i] != '') {
              let dt = filas[i].split(this.separador);
              datos.push({
                tienda: dt[0],
                presupuesto: dt[1]
              });
              tiCarg++;
            }
          }
          // console.log(`Tiendas cargadas ${tiCarg}`);
          this.tCargadas = tiCarg;
          // console.log(datos);
          this.cargarSemanas(datos);
        };

      }
    }
  }
}


@Component({
  selector: 'presu-dia-sem',
  templateUrl: '../templates/semanas/presupuesto.dia.semana.template.html'
})
export class PresupuestoXDiaSemanaComponent implements OnInit {
  public datosCargados: any;
  public separador: string = '';
  public anoSelect: string = '';
  public semSelect: string = '';

  public tiendas: TiendaEntity[] = [];
  public semanas: SemanaModel[] = [];

  tASignadas = 0;
  tCargadas = 0;

  public obsSendLogPPTO: Observable<any>;
  logsProceso: any[] = [];
  cantSinActPpto = 0;
  cantActPpto = 0;
  logFinal = '';
  bloquearConsulta = false;
  filePpto: any;

  constructor(private ts: TiendaServices, private ss: SemanaServices, private spinner: NgxSpinnerService, private router: Router, private socs: SocketServices) {
    this.obsSendLogPPTO = this.socs.registrarEvento('logPptoXDia');
  }

  ngOnInit() {
    this.ts.getAllTiendas().subscribe(d => {
      this.tiendas = d.data.tiendas;
    });

    this.obsSendLogPPTO.subscribe(d => {
      if (d.code != 0) {
        this.logsProceso.push(d);
        switch (d.code) {
          case -1:
            this.cantSinActPpto++;
            break;
          default:
            this.cantActPpto++;
            break;
        }
      } else {
        this.logFinal = d.msg;
        this.bloquearConsulta = false;
        this.spinner.hide();
      }
    });
  }

  devolverTipoLog(tipo: number) {

    switch (tipo) {
      case -1:
        return 'text-warning';
      case 1:
      case 2:
        return 'text-primary';

      case -2:
        return 'text-danger';
    }
  }

  async procesarPresupuestos(input: any) {
    let pptos: any[] = [];

    let reader = new FileReader();

    return new Promise<any>((resolve, reject) => {
      if (input.files.length > 0) {
        reader.readAsText(input.files[0]);
        reader.onload = (data) => {
          let csvData = reader.result;

          let filas = (csvData as string).split('\n');

          for (let i = 1; i < filas.length; i++) {
            if(filas[i] != "") {
              let dt = filas[i].split(this.separador);

              pptos.push({
                tienda: dt[0],
                ppto: dt[1],
                fecha1: dt[2],
                fecha2: dt[3].replace('\r', '')
              });
            }

          }

          resolve(pptos);
        };
      } else
        reject('Archivo en blanco');
    });


  }

  cargarArchivoPpto($event) {
    this.filePpto = $event.target;
  }

  async cargarPpto() {
    if (this.separador == '') {
      alert('Debe ingresar un separador');
      return;
    }
    let infoPpto = {};
    try {
      infoPpto = await this.procesarPresupuestos(this.filePpto);
    } catch (e) {
      alert('Error procesando el archivo de pptos, revise el formato del archivo asi como si es un ppto normal o por días');
      return;
    }

    if (confirm(`Desea cargar el ppto por dia para el periodo ${this.anoSelect}-${this.semSelect}`)) {
      this.logsProceso = [];
      this.bloquearConsulta = true;
      this.logFinal = "";
      this.spinner.show();

      this.socs.enviarEvento("subirPptoxDia", {
        semActual:this.semSelect,
        anoAct: this.anoSelect,
        pptos: infoPpto
      })
    }
  }

  cargarDatos($event) {
    this.datosCargados = $event;
  }

  cargarSemanas(datos: any[]) {

    this.spinner.show();
    this.ss.devolverInfoSemana(`${this.anoSelect}-${this.semSelect}`).subscribe(d => {

      this.semanas = [];


      d.data.semanas.forEach(s => {

        let sem: SemanaModel = SemanaModel.CrearSemana(s);

        this.semanas.push(sem);
      });

      let semAsig = [];
      this.semanas.forEach(s => {

        let pre = datos.filter(t => t.tienda == s.tienda);

        if (pre.length > 0) {
          // s.ventasSem = +pre.presupuesto;
          // s.recalcularPrecio();
          for (let p of pre) {
            // s.asignarPrecioXDia(p.presupuesto, p.fecha);

            s.asignarPrecioRangoDia(p.presupuesto, p.fecha1, p.fecha2);
          }
          s.recalcularPresupuestoDesdeDias();
        }
      });


      // console.log(this.semanas);
      // console.log(`Tiendas asignadas ${semAsig.length}`);
      this.tASignadas = semAsig.length;
      // console.log(`Tiendas sin presupuesto ${this.semanas.length - semAsig.length}`);


      let obs = this.ss.actualizarPresupuestoSemana(semAsig);

      forkJoin(obs).subscribe(d => {
        this.spinner.hide();

        alert(`Tiendas asignadas ${this.tASignadas}`);
        // this.router.navigate(['/']);
      });

      // obs.forEach(o => {
      //   o.subscribe(d2 => {
      //     console.log(d2);
      //   });
      // });


    });
  }

  asignarPresupuestos() {

    if (this.datosCargados) {

      let files = this.datosCargados.srcElement.files;


      let datos: any[] = [];


      let input = this.datosCargados.target;
      let reader = new FileReader();

      if (input.files.length > 0) {
        let tiCarg = 0;
        reader.readAsText(input.files[0]);

        reader.onload = (data) => {
          let csvData = reader.result;

          let filas = (csvData as string).split('\n');


          for (let i = 1; i < filas.length; i++) {

            if (filas[i] != '') {

              let dt = filas[i].split(this.separador);
              datos.push({
                tienda: dt[0],
                presupuesto: dt[1],
                fecha1: dt[2],
                fecha2: dt[3]

              });
              tiCarg++;
            }
          }
          // console.log(`Tiendas cargadas ${tiCarg}`);
          this.tCargadas = tiCarg;

          this.cargarSemanas(datos);
        };

      }
    }
  }
}


@Component({
  selector: 'lista-semana',
  templateUrl: '../templates/semanas/lista.semanas.template.html'
})
export class ListaSemanasComponent implements OnInit, OnPermisos {

  public anoSelect: number;
  public semSelect: number;

  public filtroTienda: string;

  permisos: any = {
    CREARSEMANAS: 0,
    CARGARPRESUPUESTO: 0
  };

  user: any;

  opcSem: any[] = [];

  tiendas: TiendaEntity[] = [];
  datos: any[] = [];

  rows: any[] = [];
  public tempFullRows: any[] = [];

  columns = [
    {name: 'id'},
    {name: 'Nombre'},
    {name: 'Semana'},
    {name: 'Presupuesto'},
    {name: 'Horario Tiendas'},
    {name: 'Malla Horario Empleado'},
    {name: 'Acciones'}
  ];

  constructor(private ss: SemanaServices, private ts: TiendaServices, private spinner: NgxSpinnerService, private us: UsuarioServices) {
    for (let j = 1; j <= 53; j++) {
      this.opcSem.push(j);
    }


  }

  filtrarTiendas(event) {

    let val = event.target.value.toLowerCase();

    const temp = this.tempFullRows.filter(t => t.nombre.toLowerCase().indexOf(val) !== -1 || !val);

    this.rows = temp;
  }

  ngComprobarPermisos(): void {

    this.user.rol.permisos.map(p => {
      if (p.id == PERMISOS.CREARMALLA)
        this.permisos.CREARSEMANAS = 1;

      if (p.id == PERMISOS.CARGARPRESUPUESTO)
        this.permisos.CARGARPRESUPUESTO = 1;
    });
  }

  ngOnInit() {
    this.spinner.show();
    this.ts.getAllTiendas().subscribe(d => {
      console.log(d.data);
      this.tiendas = d.data.tiendas;
      this.tiendas = this.tiendas.filter(t => t.activo);
      this.spinner.hide();
    });

    this.us.getUser(getLoginUser()).subscribe(d => {


      this.user = d.data.usuario;
      this.ngComprobarPermisos();
    });
  }

  consultarSemana() {
    if (this.anoSelect == null) {
      alert('No se ha seleccionado un año valido');
      return;
    }

    if (this.semSelect == null) {
      alert('No se ha seleccionado una semana valida');
      return;
    }

    this.spinner.show();
    this.ss.devolverInfoSemana(`${this.anoSelect}-${this.semSelect}`).subscribe(d => {

      console.log(d.data);

      this.rows = [];
      this.tempFullRows = [];

      this.rows = [...this.rows];

      let semanas = d.data.semanas;
      // let horarios = d.data.horarios;


      for (let t of this.tiendas) {
        let foundSem = semanas.find(s => s.tienda == t.idDB);
        // let foundHor = horarios.find(h => h.tienda == t.idDB);
        let hor = undefined;
        let presupuesto = undefined;

        if (foundSem) {


          if (foundSem.estado.horario != 0)
            hor = 1;

          if (foundSem.estado.presupuesto != 0)
            presupuesto = 1;
        }


        this.rows.push({
          id: t.idDB,
          nombre: t.nombre,
          semana: (foundSem != undefined),
          presupuesto: (presupuesto != undefined),
          horarioTiendas: (t.horario != null && t.horario != '') ? 'Si' : 'No',
          mallaHorarioEmpleado: (hor != undefined) ? 'Si' : 'No',
          acciones: (presupuesto != undefined) ? t.id : undefined
          // acciones: t.id
        });

        this.tempFullRows.push({
          id: t.idDB,
          nombre: t.nombre,
          semana: (foundSem != undefined),
          presupuesto: (presupuesto != undefined),
          horarioTiendas: (t.horario != null && t.horario != '') ? 'Si' : 'No',
          mallaHorarioEmpleado: (hor != undefined) ? 'Si' : 'No',
          acciones: (presupuesto != undefined) ? t.id : undefined
        });
      }
      this.rows = [...this.rows];

      this.spinner.hide();
    });
  }

}
